// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"VideoJs_videoWrapper___Nsyk"};